<template>
    <div class="sidebar">
        <div class="sidebar-wrapper">
            <ul class="nav flex text-white flex-col py-4 px-1">

              <router-link to="/dashboard" class="nav-item" active-class="active">
                <div class="nav-link">
                  <i class="fa-solid fa-table-cells-large nav-link-icon"/>
                  <p>{{$t('sidebar.dashboard')}}</p>
                </div>
              </router-link>

              <router-link to="/base-monitoring" class="nav-item" active-class="active">
                <div class="nav-link">
                  <i class="fa-solid fa-chart-column nav-link-icon"/>
                  <p>{{$t('sidebar.baseMonitoring')}}</p>
                </div>
              </router-link>

              <router-link to="/pledge-monitoring" class="nav-item" active-class="active">
                <div class="nav-link">
                  <i class="fa-solid fa-chart-column nav-link-icon"/>
                  <p>Гаров мониторинги</p>
                </div>
              </router-link>

              <router-link to="/pledge" class="nav-item" active-class="active">
                <div class="nav-link">
                  <i class="fa-solid fa-list nav-link-icon"/>
                  <p>Гаровлар</p>
                </div>
              </router-link>

              <router-link to="/targeted-inspection-monitoring" class="nav-item" active-class="active">
                <div class="nav-link">
                  <i class="fa-solid fa-user-tie nav-link-icon w-8 h-8"/>
                  <p>Мақсадли инспексион мониторинг</p>
                </div>
              </router-link>

              <router-link to="/didox-report" class="nav-item" active-class="active">
                <div class="nav-link">
                  <i class="fa-solid fa-file-lines nav-link-icon"/>
                  <p>Didox ҳужжатлар</p>
                </div>
              </router-link>

            </ul>
        </div>

    </div>
</template>

<script>

import {mapActions} from "vuex";

export default {
  name: "Sidebar",
  data() {
    return {
    }
  },

  methods: {
    // ...mapActions(["initMenus"])
  },
  mounted() {
    // this.initMenus()
  }
}

</script>
